import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

/** Figma 641:4730 / 714:3485 — email HTML split pane. */
export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    height: '100%',
    backgroundColor: '#f6f7f9',
    borderLeft: '1px solid #e2e2e2',
    boxShadow: '-2px 0px 3px rgba(0,0,0,0.12)',
    padding: '24px 24px 0',
    gap: 16,
    boxSizing: 'border-box',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    flexShrink: 0,
    height: 24,
  },
  title: {
    margin: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#2e3132',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
  },
  iconButton: {
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    borderRadius: 4,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: '#6a777a',
    '& svg': {
      fontSize: 12,
      color: '#6a777a',
    },
    '&:hover': {
      backgroundColor: theme.palette.labraChat?.hoverBg || '#eef0f3',
    },
  },
  frame: {
    flex: 1,
    minHeight: 0,
    width: '100%',
    border: 'none',
    borderRadius: 8,
    backgroundColor: '#ffffff',
  },
}))
